import { frontendURL } from '../../../../helper/URLHelper';
import store from 'dashboard/store';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Grupos from './Grupos.vue';
import EditorDoPapel from './EditorDoPapel.vue';

// ACESSO-01 (L9a): Configurações → Papéis, com a chave ACESSO_GRANULAR ligada: a lista (aba Papéis), a aba Grupos e o
// editor do papel. Montar papel é entregar acesso: só quem tem o `roles:manage` (o modelo Administrador), e, com a chave
// desligada, o administrador, como a tela de hoje.
//
// Com a chave desligada, estas rotas voltam para a tela de hoje (`custom_roles_list`), e a tela de hoje, com ela ligada,
// vem para cá (`customRoles.routes.js`). O store já tem o perfil no `beforeEnter`: o `beforeEach` de `routes/index.js`
// espera o `setUser` antes de qualquer guarda de rota.
const META = { permissions: ['administrator'], escopos: ['roles:manage'] };

export const soComAChaveLigada = to =>
  store.getters['acesso/ligado'] === true || {
    name: 'custom_roles_list',
    params: { accountId: to.params.accountId },
  };

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/papeis'),
      component: SettingsWrapper,
      // Sem cache: a lista e os grupos voltam do editor relidos, com o que ele acabou de gravar.
      props: { keepAlive: false },
      beforeEnter: soComAChaveLigada,
      children: [
        { path: '', name: 'papeis_lista', component: Index, meta: META },
        {
          path: 'grupos',
          name: 'papeis_grupos',
          component: Grupos,
          meta: META,
        },
        {
          path: 'novo',
          name: 'papeis_novo',
          component: EditorDoPapel,
          meta: META,
        },
        {
          path: ':papelId',
          name: 'papeis_editor',
          component: EditorDoPapel,
          meta: META,
        },
      ],
    },
  ],
};
